import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import StockUpgradeDowngradeFull from './StockUpgradeDowngradeFull';
import { Helmet } from "react-helmet";

class StockUpgradeDowngradeWrap extends Component {

  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Upgrades Or Downgrades</title>
          <link rel="canonical" href="https://www.vizfm.com/upgradeDowngrade" />
          <meta name="description" content="Symbol or Stock Upgrades, Downgrades or Holds" />
        </Helmet>

        <Container fluid className="p-2">
          <Row>
            <Col>
            Upgrades Or Downgrades
              <StockUpgradeDowngradeFull limit={100} />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default StockUpgradeDowngradeWrap;
